import * as ReactDOM from "react-dom/client";
import { StrictMode } from "react";

import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <StrictMode>
    <App />
  </StrictMode>
);
